import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Map, TileLayer, Marker } from "react-leaflet";
import { debounce, cloneDeep } from "lodash";
import JoditEditor from "jodit-react";

import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Switch,
  Tabs,
  Table,
  Tooltip,
  Typography,
  Upload,
  message,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  InboxOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";


class SettingsPage extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "1",
      data: {},
      showDrawer: true,
      DrawerData: ""
    };

    this.formTransportRef = React.createRef();
    this.formTaxRef = React.createRef();
    this.formPrivacyRef = React.createRef();
    this.formRulesRugulationRef = React.createRef();
    this.formAboutUsRef = React.createRef();
    this.formOurBranchesRef = React.createRef();
    this.formUserJobsRef = React.createRef();
   
    this.formServiceRadiusRef = React.createRef();
  

  }

  fetch = (type="shipping") => {
    this.setState({ loading: true });

    API.setting
      .list(type)
      .then((result) => {
        this.setState({ loading: false, data: result });
        if (type == "shipping"){
          this.formTransportRef.current.setFieldsValue(result)
        }else if(type == "tax"){
          this.formTaxRef.current.setFieldsValue(result)
        }else if(type == "privacy"){
          this.formPrivacyRef.current.setFieldsValue(result)
          this.setState({DrawerData: result.privacy})

        }else if(type == "rules_regulations"){
          this.formRulesRugulationRef.current.setFieldsValue(result)
          this.setState({DrawerData: result.rules_regulations})

        }else if(type == "about_us"){
          this.formAboutUsRef.current.setFieldsValue(result)
          this.setState({DrawerData: result.about_us})
        }
        else if(type == "our_branches"){
          this.formOurBranchesRef.current.setFieldsValue(result)

        }

    
      
        else if(type == "user_jobs"){
          this.formUserJobsRef.current.setFieldsValue(result)
        }
      
        else if(type == "service_radius"){
          this.formServiceRadiusRef.current.setFieldsValue(result)
        }
     
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    const formData = new FormData();

    switch (this.state.activeTab) {
      case "1":
        values.type =  "shipping";
        break;
      case "2":
        values.type =  "tax";
        break;
      case "3":
        values.type =  "privacy";
        values.privacy = this.state.DrawerData;
        break;

      case "4":
        values.type =  "rules_regulations";
        values.rules_regulations = this.state.DrawerData;

        break;

      case "5":
        values.type =  "about_us";
        values.about_us = this.state.DrawerData;

        break;


      case "6":
        values.type =  "our_branches";
        break;

      case "7":
        values.type =  "user_jobs";
        break;

      
      case "8":
        values.type =  "service_radius";
        break;
     
      default:
        break;
    }

    API.setting
      .update(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.fetch(values.type);
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTabChange = (e) =>{

    this.setState({activeTab: e})

    let type = "shipping"
    if (e == "2")
      type = "tax"
    if (e == "3")
      type = "privacy"

    if (e == "4")
      type = "rules_regulations"

    if (e == "5")
      type = "about_us"

    if (e == "6")
      type = "our_branches"


    if (e == "7")
      type = "user_jobs"

  

    if (e == "8")
      type = "service_radius"

  

    this.fetch(type)

  }

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    this.fetch();
  }
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  }
  changeDrawer = (data) => {
    console.log("data is: ", data)
    this.setState({DrawerData: data})

  }
  render() {
    const { activeTab, data, inviteImageList, loading, submitting } =
      this.state;

    const config = {
      readOnly: false,
      uploader: {
        insertImageAsBase64URI: true,
        insert: true,
      }
    }
    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.settings}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Tabs
            activeKey={activeTab}
            type="card"
            onTabClick={this.handleTabChange}
          >

            <Tabs.TabPane tab={Resources.transportation} key="1" disabled={loading}>
              <Form ref={this.formTransportRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="value"
                      label={`${Resources.costService}`}
                    >
                      <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={submitting}
                      block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>

            <Tabs.TabPane tab={Resources.tax} key="2" disabled={loading}>
              <Form ref={this.formTaxRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={8}>
                    <Form.Item
                        name="value"
                        label={`${Resources.tax}  (${Resources.percent})`}
                    >
                      <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.privacy} key="3" disabled={loading}>
              <Form ref={this.formPrivacyRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={24}>
                      {/*<span >{t("description")}</span>:*/}
                      <JoditEditor
                          ref={this.formRef} // tabIndex of textarea
                          tabIndex={3} // tabIndex of textarea
                          value={this.state.DrawerData}
                          config={config}
                          // onChange={this.changeDrawer}
                          onBlur={(newContent) => {
                            this.setState({DrawerData: newContent})
                          }}
                      />
                    {/*<Form.Item name="privacy" label={Resources.text} rules={Rules.required}>*/}
                    {/*  <Input.TextArea rows={6} />*/}
                    {/*</Form.Item>*/}
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.rulesAndRegulations} key="4" disabled={loading}>
              <Form ref={this.formRulesRugulationRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={24}>
                    <JoditEditor
                        ref={this.formRef} // tabIndex of textarea
                        tabIndex={3} // tabIndex of textarea
                        value={this.state.DrawerData}
                        config={config}
                        // onChange={this.changeDrawer}
                        onBlur={(newContent) => {
                          this.setState({DrawerData: newContent})
                        }}
                    />
                    {/*<Form.Item name="rules_regulations" label={Resources.text} rules={Rules.required}>*/}
                    {/*  <Input.TextArea rows={6} />*/}
                    {/*</Form.Item>*/}
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.aboutUs} key="5" disabled={loading}>
              <Form ref={this.formAboutUsRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={24}>
                    <JoditEditor
                        ref={this.formRef} // tabIndex of textarea
                        tabIndex={3} // tabIndex of textarea
                        value={this.state.DrawerData}
                        config={config}
                        // onChange={this.changeDrawer}
                        onBlur={(newContent) => {
                          this.setState({DrawerData: newContent})
                        }}
                    />
                    {/*<Form.Item name="about_us" label={Resources.text} rules={Rules.required}>*/}
                    {/*  <Input.TextArea rows={6} />*/}
                    {/*</Form.Item>*/}
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.ourBranches} key="6" disabled={loading}>
              <Form ref={this.formOurBranchesRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24} style={{marginTop: "10px"}}>
                      <Form.List name="our_branches">
                        {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }) => (
                                  <Fragment key={key}>

                                    <Col xs={4}>
                                      <Form.Item
                                          name={[name, "title"]}
                                          label={Resources.title}
                                          rules={Rules.required}
                                          {...restField}
                                      >
                                        <Input 	 />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={6}>
                                      <Form.Item
                                          name={[name, "address"]}
                                          label={Resources.address}
                                          rules={Rules.required}
                                          {...restField}
                                      >
                                        <Input 	 />
                                      </Form.Item>
                                    </Col>

                                    <Col xs={6}>
                                      <Form.Item
                                          name={[name, "phone"]}
                                          label={Resources.phone}
                                          {...restField}
                                      >
                                        <Input 	 />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={6}>
                                      <Form.Item
                                          name={[name, "fax"]}
                                          label={Resources.fax}
                                          {...restField}
                                      >
                                        <Input 	 />
                                      </Form.Item>
                                    </Col>
                                    <Col xs={2}>
                                      <Button
                                          type="link"
                                          onClick={() => remove(name)}
                                          style={{
                                            marginTop: 32,
                                            padding: 0,
                                            color:"red"
                                          }}
                                          block
                                      >
                                        {Resources.delete}
                                        {/*<i className="fa fa-minus-circle" />*/}
                                      </Button>
                                    </Col>
                                  </Fragment>
                              ))}
                              <Col xs={24}>
                                <Form.Item>
                                  <Button
                                      type="dashed"
                                      onClick={() => add()}
                                      block
                                  >
                                    {`${Resources.add}`}
                                  </Button>
                                </Form.Item>
                              </Col>
                            </>
                        )}
                      </Form.List>


                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                    </Row>

              </Form>
            </Tabs.TabPane>
        
        

            <Tabs.TabPane tab={Resources.serviceRadius} key="8" disabled={loading}>
              <Form ref={this.formServiceRadiusRef} onFinish={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col xs={24} md={8}>
                    <Form.Item
                        name="value"
                        label={`${Resources.serviceRadius}  (km)`}
                    >
                      <InputNumber min={0} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={{ span: 4, offset: 20 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                        block
                    >
                      {Resources.record}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(SetRoute(data)),
  };
})(SettingsPage);
